/**
 * Remove $rankFieldMigrated and rankField once fun-1404_migrate_rank_field_id_source is cleaned up
 */

export const QUERY = `
query JiraBusinessConfiguration($cloudId: ID!, $rankFieldMigrated: Boolean!) {
  jira {
    rankField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: RANK) @skip(if: $rankFieldMigrated) {
      fieldId
      name
    }
    startDateField: jwmAliasFieldConfig(cloudId: $cloudId, aliasFieldOption: START_DATE) {
      fieldId
      name
    }
    issueLinkTypes(cloudId: $cloudId) {
      totalCount
    }
  }
}
`;
